import {GDPRZone} from "../../enums/gdpr/gdpr-zone.enum";

/**
 * Returns the GDPR public form description text based on the GDPR zone.
 *
 * @param gdprZone The GDPR zone (EU or UAE)
 * @returns HTML string with the GDPR consent description for public forms
 */
export function getGDPRPublicFormDescription(gdprZone: GDPRZone): string {
  if (gdprZone === GDPRZone.UAE) {
    return (
      `<p>ATOZ Tax Advisers Middle East would like to stay connected with you!</p>` +
      `<p>In compliance with applicable data protection laws and in particular
      the DIFC Law No.5/2020, including any amendments (together, the Data
      Protection Law), we require your express consent to receive emails from us,
      such as news, updates, and invitations to events from ATOZ Tax Advisers
      Middle East.</p>` +
      `<p>Please note that we use a secure EU-based communication platform
      provider, dotdigital, for the purpose of sharing our marketing communications
      and optimising their release. Therefore, by consenting to receive our
      communications, you are consenting to provide your basic professional data
      (being your first & last name, professional email address, related company,
      and job title). Such data will be stored in dotdigital for the duration of
      your consent and be deleted immediately thereafter.</p>`
    );
  } else {
    return (
      `<p>ATOZ would like to stay connected with you!</p>` +
      `<p>In compliance with the provisions of EU Regulation n°2016/679 of 27
      April 2016 on the protection of natural persons with regard to the processing
      of personal data and on the free movement of such data (the General Data
      Protection Regulation), we require your explicit consent to receive emails
      from us, such as updates and invitations from ATOZ Tax Advisers or its
      ATOZ-affiliated companies.</p>` +
      `<p>Please note that we use an EU-based communication platform provider,
      dotdigital, for the purpose of sharing our marketing communications and
      optimising their release. By consenting to receive our communications, you
      agree to provide your basic professional data (your first & last name,
      company, and job title). This data will be stored in dotdigital for the
      duration of your consent and deleted immediately afterwards.</p>`
    );
  }
}

/**
 * Returns the GDPR compliance text to be included in emails, based on the GDPR zone.
 *
 * @param gdprZone The GDPR zone (EU or UAE)
 * @returns A string containing the compliance text for email bodies
 */
export function getEmailBody(gdprZone: GDPRZone): string {
  if (gdprZone === GDPRZone.UAE) {
    return 'In compliance with applicable data protection laws and in particular the DIFC Law No.5/2020,' +
      ' including any amendments (together, the Data Protection Law)'
  } else {
    return 'In compliance with the provisions of EU Regulation n°2016/679 of 27 April 2016 on the protection ' +
      'of natural persons with regard to the processing of personal data and on the free movement' +
      ' (the General Data Protection Regulation) in effect as from 25 May 2018'
  }
}
